import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { UserDAO } from '../../../../../../../core/services/dao/userDAO';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-description-and-features-form',
  templateUrl: './description-and-features.component.html',
  styleUrls: ['./description-and-features.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class DescriptionAndFeaturesFormComponent implements OnInit, OnDestroy {
  @Input() vessel: Vessel;
  @Input() features: any[];

  currentFeature: string;
  isAdmin = false;
  subs: Subscription[] = [];
  descModel: Partial<Vessel>;

  constructor(
    private userDAO: UserDAO,
    private vesselDAO: VesselDAO,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.setDescModel();
    this.userDAO.getCurrentUser().roles.map((role) => {
      if (role.adminAccess) {
        this.isAdmin = true;
      }
    });
  }

  addFeature() {
    this.features.push(this.currentFeature);
    this.currentFeature = '';
    this.setDescModel();
  }

  removeFeature(feature) {
    this.features.splice(this.features.indexOf(feature), 1);
    this.setDescModel();
  }

  ngOnDestroy(): void {}

  descriptionContentChanged(event: string) {
    this.vessel.description = event;
    this.setDescModel();
  }

  buyflowText1Changed(event: string) {
    this.vessel.adminBuyflowText1 = event;
    this.setDescModel();
  }

  buyflowText2Changed(event: string) {
    this.vessel.adminBuyflowText2 = event;
    this.setDescModel();
  }

  setDescModel(): void {
    this.descModel = {
      id: this.vessel.id,
      displayTitle: this.vessel.displayTitle,
      description: this.vessel.description,
      adminBuyflowTitle1: this.vessel.adminBuyflowTitle1,
      adminBuyflowText1: this.vessel.adminBuyflowText1,
      adminBuyflowTitle2: this.vessel.adminBuyflowTitle2,
      adminBuyflowText2: this.vessel.adminBuyflowText2,
      features: this.features,
    } as Partial<Vessel>;
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
